/** Map axios / network failures to user-facing messages. */

export function getApiErrorMessage(err, fallback) {
  if (!err?.response) {
    if (err?.code === 'ECONNABORTED') {
      return 'Request timed out. Check your connection and try again.';
    }
    if (typeof navigator !== 'undefined' && !navigator.onLine) {
      return 'You appear to be offline. Reconnect and try again.';
    }
    return fallback;
  }

  const status = err.response.status;
  const serverError = err.response.data?.error;

  if (status === 429) {
    return 'Too many requests. Wait a moment and try again.';
  }
  if (status === 403) {
    return serverError || 'You do not have permission to open this link.';
  }
  if (status === 404) {
    return serverError || 'This link was not found or has expired.';
  }
  if (status >= 500) {
    return 'Something went wrong on our side. Try again in a few minutes.';
  }

  return serverError || fallback;
}

export function isConsumedOrExpiredError(message) {
  if (!message) return false;
  return (
    message.includes('already been viewed')
    || message.includes('has expired')
    || message.includes('One-time secrets can only be accessed once')
    || message.includes('already been used')
  );
}
